<template>
  <el-main class="rh-medtable">
    <h1>Contrats</h1>
    <app-table
      tablenom="medcontrats"
      :cols="colonnes"
      :items="contrats"
      :loadstatus="contratsLoadStatus"
      :deletestatus="contratDeleteStatus"
      :formroutes="contFormRoutes"
      :actions="contActions"
      :ismeddetail="true"
    >
    </app-table>
  </el-main>
</template>
<script>
import AppTable from "@/components/rh/ui/table/AppTable";

export default {
  components: { "app-table": AppTable },
  data() {
    return {
      idMed: this.$route.params.idmed, // récupère le id du médecin dans l'url
      contFormRoutes: {
        edit: {
          route: "med_contrats_edit",
          params: { idmed: "id_med", idcont: "id" },
        },
        create: {
          route: "med_contrats_create",
          params: { idmed: this.$route.params.idmed },
        },
      },
    };
  },
  computed: {
    contratsLoadStatus() {
      // 1 = loading, 2 = succès, 3 = échec du chargement des données
      return this.$store.state.contl.contratsLoadStatus;
    },
    contratDeleteStatus() {
      // 1 = deleting, 2 = succès, 3 = échec
      return this.$store.state.contl.contratDeleteStatus;
    },
    contrats() {
      // n'affiche que les contrats du médecin sélectionné
      return this.$store.state.contl.contrats.filter(
        (c) => c.id_med == this.idMed
      );
    },
    colonnes() {
      // n'affiche pas la colonne 'noms des médecins'
      return this.$store.state.contl.colonnes.filter(
        (col) => col.prop != "medecin"
      );
    },
    contActions() {
      return this.$store.state.contl.actions;
    },
  },
};
</script>
